/* eslint-disable no-control-regex */
/**
 * Utilitários de Segurança e Sanitização de Entradas (Anti-Injeção e Defacement)
 */

/**
 * Remove caracteres de controle, tags HTML e sequências perigosas de um texto comum
 * @param {string} value
 * @param {number} maxLength
 * @returns {string}
 */
export function sanitizeText(value, maxLength = 100) {
  if (value === null || value === undefined) return ''
  const str = String(value)
    // Remove bytes nulos e caracteres de controle invisíveis
    .replace(/[\x00-\x1F\x7F-\x9F]/g, '')
    // Remove tags HTML (<script>, <img>, etc.)
    .replace(/<[^>]*>?/gm, '')
    // Remove tentativas de javascript: ou data:
    .replace(/javascript:/gi, '')
    .replace(/vbscript:/gi, '')
    .replace(/data:/gi, '')
    .trim()

  return str.slice(0, maxLength)
}

/**
 * Sanitiza o campo de usuário/email de login
 * @param {string} value
 * @returns {string}
 */
export function sanitizeUsername(value) {
  return sanitizeText(value, 100)
}

/**
 * Sanitiza a senha (remove bytes nulos que podem quebrar bibliotecas no backend e limita tamanho para evitar DoS)
 * @param {string} value
 * @returns {string}
 */
export function sanitizePassword(value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/\x00/g, '')
    .slice(0, 128)
}

/**
 * Sanitiza e valida a unidade/empresa (string alfanumérica maiúscula, máximo 5 caracteres)
 * @param {string|number} value
 * @returns {string}
 */
export function sanitizeEmpresa(value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 5)
}

/**
 * Sanitiza e valida a placa de veículo (apenas letras maiúsculas e números, máximo 7 caracteres)
 * @param {string} value
 * @returns {string}
 */
export function sanitizePlaca(value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 7)
}

/**
 * Sanitiza e valida o número do romaneio (apenas dígitos numéricos, máximo 10 caracteres)
 * @param {string|number} value
 * @returns {string}
 */
export function sanitizeRomaneio(value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/\D/g, '')
    .slice(0, 10)
}
